export default "__VITE_ASSET__aO2oXTeZ__"